
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Attestation from '@/extend/classes/Attestation';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeAttestation' })

export default class storeAttestation extends VuexModule {
  // States
  private reccords: Attestation[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get attestationLoading (): boolean {
    return this.dataLoading;
  }
  private get attestationRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get attestationLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewAttestation() {
    return (): Attestation => { 
      return this.getAttestation(0, true);
    }
  }

  
  public get getAttestation () {
    return (id: number, canCreate = false): Attestation => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Attestation can't be 0")
        return new Attestation();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Attestation();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Attestation.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromAttestation(data.reccords[0] as Attestation);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listAttestation (): Attestation[] {
    return this.reccords;
  }

  public get listConfigAttestation (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mAttestationRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mAttestationClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mAttestationLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mAttestationLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Attestation.fromJson(reccord as Attestation));
    })
    Attestation.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mAttestationConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mAttestationCreated (obj: Attestation): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAttestation(obj)) {
          api.fromAttestation(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareAttestation(obj)) {
            api.fromAttestation(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mAttestationUpdated (obj: Attestation): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAttestation(obj)) {
          api.fromAttestation(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mAttestationDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerAttestation (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.attestationRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerAttestation(this.attestationCreated, this.attestationUpdated, this.attestationDeleted);
          this.mAttestationRegistered();
        } else {
          setTimeout(() => resolve(this.registerAttestation(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.attestationLoading && !this.attestationLoaded) {
          this.mAttestationLoading(true);
          return Attestation.list(filter)
            .then((data: ListData) => {
              this.mAttestationLoaded(data);
              this.mAttestationLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredAttestation (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.attestationLoading) {
        this.mAttestationLoading(true);
        return Attestation.list(filter)
          .then((data: ListData) => {
            this.mAttestationLoaded(data);
            this.mAttestationLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createAttestation (obj: Attestation): Promise<Attestation> {
    return new Promise((resolve, reject) => {
      return Attestation.fromJson(obj).createForStoreAttestation()
        .then((reccords) => {
          this.mAttestationCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateAttestation (obj: Attestation): Promise<Attestation> {
    return new Promise((resolve, reject) => {
      return Attestation.fromJson(obj).updateForStoreAttestation()
        .then((reccords) => {
          this.mAttestationUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteAttestation (obj: Attestation): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Attestation.fromJson(obj).deleteForStoreAttestation()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mAttestationDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private attestationCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAttestationConfigUpdated(config)
    const obj = objConfig.obj as Attestation;
    this.mAttestationCreated(Attestation.fromJson(obj));
  }

  @Action
  private attestationUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAttestationConfigUpdated(config)
    const obj = objConfig.obj as Attestation;
    this.mAttestationUpdated(Attestation.fromJson(obj));
  }

  @Action
  private attestationDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Attestation;
    this.mAttestationDeleted(obj.id);
  }
}
